export default __webpack_public_path__ + "static/media/Somnium_Space.95d94860.png";